import type { ImportRow } from "./itemImport.api";
import { selectedImportRows } from "./itemImportSelection";

const CHECK_INTERVAL_MS = 3000;

export async function checkSelectedImportGids(
  rows: ImportRow[],
  lookup: (row: ImportRow) => Promise<string>,
  onResult: (row: ImportRow, gid: string, error?: unknown) => void,
  wait: (ms: number) => Promise<void> = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
): Promise<void> {
  for (const [index, row] of selectedImportRows(rows).entries()) {
    if (index > 0) await wait(CHECK_INTERVAL_MS);
    let gid = "";
    let error: unknown;
    try {
      gid = await lookup(row);
    } catch (caught) {
      error = caught;
    }
    onResult(row, gid, error);
  }
}
